import React, { useState, lazy, Suspense, useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import './style/main.sass';
import Home from 'pages/Home';
import Music from 'pages/Music';
import Concerts from 'pages/Concerts';
import ArtistConcerts from 'pages/ArtistConcerts';
import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import Hamburger from 'components/Hamburger';
import Fallback from 'components/Fallback';
import Modal from 'components/Modal';
import ConcertVideos from 'pages/ConcertVideos';
import ConcertVideoPage from "pages/ConcertVideoPage"
import FavouritesPage from 'pages/FavouritesPage'
import ForgotPass from 'components/ForgotPass';
import ForgotPassRewrite from 'components/ForgotPassRewrite';
import PurchasedProduct from "pages/PurchasedProduct"
import AdminPanel from "components/AdminPanel"

const Footer = lazy(() => import('components/Footer'));

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [isOpenModal, setIsOpenModal] = useState(false);
  
  const [currentContentModal, setCurrentContentModal] = useState({})

  const [user, setUser] = useState({})

  
	useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"))
    if (token) {
      setUser(token.userObj)
    }

  }, [])
	

  return (
    <div className="App">
      <Header scrollActivation={true} setIsOpenModal={setIsOpenModal} setCurrentContentModal={setCurrentContentModal}/>
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}  setIsOpenModal={setIsOpenModal} setCurrentContentModal={setCurrentContentModal}/>
      <Hamburger sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="content">
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/concerts" component={Concerts} />
          <Route exact path="/music" component={Music} />
          <Route exact path="/concertVideos" component={ConcertVideos} />
          <Route exact path="/favourites" component={FavouritesPage} />
          <Route exact path="/forgot-pass" component={ForgotPass} />

          <Route exact path="/reset-password/:token" component={ForgotPassRewrite} />
          <Route exact path="/purchased" component={PurchasedProduct} />
                 {
              user?._id === process.env.REACT_APP_ADMIN_ID && (
            <Route path="/admin" component={AdminPanel} />
            )
          }
          <Route path="/concert/:id" component={ConcertVideoPage} />
          <Route path="/artist/:name" component={ArtistConcerts} />
   

        </Switch>
        {isOpenModal && <Modal onClose={() => setIsOpenModal(false)}>{currentContentModal}</Modal>}
      </div>
      <Suspense fallback={<Fallback />}>
        <Footer />
      </Suspense> 
    </div>
  );
}

export default App;
